import { Component, Input } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipDirective } from '../../tooltip/tooltip.directive';
import { IPriceBookViewDTO } from 'src/app/features/pricebook/models/pricebook.model';
import { PricebookService } from 'src/app/features/pricebook/services/pricebook.service';
import { SvgIconComponent } from 'src/app/ui/svg-icon/svg-icon.component';

@Component({
  selector: 'app-gift-tooltip',
  standalone: true,
  imports: [NgIf, NgFor, SvgIconComponent, TranslateModule, TooltipDirective],
  templateUrl: './gift-tooltip.component.html',
  styleUrls: ['./gift-tooltip.component.scss'],
})
export class GiftTooltipComponent {
  @Input() gifts: IPriceBookViewDTO[] = [];
  @Input() parameters: {
    amount: number | null;
    quantity: number | null;
    total_amount?: number | null;
    total_quantity?: number | null;
  } | null = null;
  
  constructor(private pricebookService: PricebookService) {}

  getGiftMessage(gift: IPriceBookViewDTO): { pricebook: string; message: string } {
    // If the gift is based on total order amount or total order quantity, use the total amount and quantity of the order
    // This case should only happen when the gift is of type extra_discount_on_products and the pricebook has thresholds
    if(gift.calculation_type === 'extra_discount_on_products' &&
        gift.thresholds &&
        gift.thresholds.length > 0 &&
        ['total_order_amount', 'total_order_quantity'].includes(gift.tierd_logic_based_on)) {
      const total_amount = this.parameters?.total_amount;
      const total_quantity = this.parameters?.total_quantity;
      return this.pricebookService.getRewardMessage(gift, total_amount, total_quantity);
    }

    const amount = this.parameters?.amount || null;
    const quantity = this.parameters?.quantity || null;
    return this.pricebookService.getRewardMessage(gift, amount, quantity);
  }
}
